module.exports = __webpack_public_path__ + "img/dactilar.9d1cdb62.png";